import { motion } from 'framer-motion';
import Button from '../../UI/Button';

// Product-specific testimonial content for David
const testimonialContent = {
  nad: {
    quote: "I play my best golf at 55. My tennis elbow and shoulder pain are gone!",
    highlight1: "best golf",
    highlight2: "pain are gone",
    result: "reversed years of aging and became pain-free",
    timeframe: "4 months"
  },
  glutathione: {
    quote: "At 55, people mistake me for mid-40s. My skin looks healthier than it has in decades!",
    highlight1: "mid-40s",
    highlight2: "healthier than",
    result: "achieved visibly younger, healthier skin",
    timeframe: "3 months"
  },
  vitaminb12: {
    quote: "I have the stamina of my 30s. No more dragging myself through meetings or workouts!",
    highlight1: "stamina of my 30s",
    highlight2: "dragging myself",
    result: "regained the energy and focus of his younger years",
    timeframe: "6 weeks"
  },
  lcarnitine: {
    quote: "I've gained muscle and lost fat at 55. My performance rivals guys half my age!",
    highlight1: "gained muscle",
    highlight2: "half my age",
    result: "transformed his body composition and performance",
    timeframe: "4 months"
  }
};

export default function TestimonialScreen2({ product, onContinue, onBack }) {
  const content = testimonialContent[product?.id] || testimonialContent.nad;

  // Split quote to highlight specific parts
  const quoteText = content.quote;
  const parts = quoteText.split(new RegExp(`(${content.highlight1}|${content.highlight2})`, 'gi'));

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="max-w-2xl mx-auto"
    >
      <div className="bg-white rounded-luxury shadow-luxury p-8">
        {/* Quote */}
        <h2 className="text-2xl md:text-3xl font-bold text-charcoal text-center mb-8 leading-relaxed">
          "{parts.map((part, index) => {
            const isHighlight = part.toLowerCase() === content.highlight1.toLowerCase() ||
                              part.toLowerCase() === content.highlight2.toLowerCase();
            return isHighlight ? (
              <span key={index} className="text-renuvia-gold">{part}</span>
            ) : (
              <span key={index}>{part}</span>
            );
          })}"
        </h2>

        {/* Image */}
        <div className="mb-8">
          <div className="relative w-full aspect-[4/3] bg-gradient-to-br from-warm-beige to-gray-100 rounded-xl overflow-hidden">
            <img
              src="/images/boosters/man-golfing.jpg"
              alt="Man golfing - active lifestyle photo"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>

        {/* Caption */}
        <p className="text-center text-charcoal text-lg mb-8">
          David <strong>{content.result}</strong> in just <span className="text-renuvia-gold font-bold">{content.timeframe}</span>.
        </p>

        <div className="flex gap-4">
          <Button onClick={onBack} variant="ghost" className="w-1/4">
            ←
          </Button>
          <Button onClick={onContinue} variant="primary" className="w-3/4">
            Next →
          </Button>
        </div>
      </div>
    </motion.div>
  );
}
